var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m407.84 243.49c22.734-36.396 13.394-43.004-10.313-43.004h-23.792c-0.088 0-1.322-1.233-9.606 7.05-9.87 4.936-33.396 5.551-33.396 7.667 0 3.966 61.949-2.731 77.635 0 8.373 1.321-1.321 17.977-3.878 28.198-0.44 3.966 2.117 2.028 3.35 0.089zm-98.786 19.915c56.396-18.77 85.743-21.062 89.884-23.087 3.879-2.557-3.876-5.816-23.088-5.112-45.557 1.939-121.26 32.693-152.1 47.497l-27.052-82.217h173.25c-2.38-24.85-134.74-19.916-297.77-19.916l-46.175 216.34c173.07-85.742 228.15-114.82 283.05-133.5zm-223.39-148.31c223.21 47.322 290.8 57.896 292.65 75.08 32.076 0 40.448 0 46.176 5.816 18.595 17.359-12.865 59.658-12.865 59.658-3.878 2.556-358.13 141.17-358.13 141.17h372.84l59.66-281.73h-400.34z",
    fill: "#02599E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsps);
export default __webpack_public_path__ + "static/media/usps.59ac212dbd54be0cceddac69bc82b923.svg";
export { ForwardRef as ReactComponent };